import React, { useEffect, useState} from 'react'
import { sprintActiveStatus } from '../../ProjectManagement/Service/TaskService';
import Skeleton from 'react-loading-skeleton';

function SprintRules() {


  return (
    <>
      {/* {loading ? (
        <Skeleton height={280} width="100%" />
      ) : ( */}
        <div className="og-card-box">
          <div className="ch-box">
            <i className="ch-icon fa-solid fa-shield-halved"></i>
            <h5>Sprint rules</h5>
          </div>

          <div className="cb-box sprint-rules-box">
            <div className="rule-row">
              <div className="rule-icon rule-green-bg">
                <i className="fa-solid fa-bolt rule-green-icon"></i>
              </div>

              <div className="rule-text">
                <strong>One active sprint</strong> per
                project at a time. A second cannot
                start until the first is stopped or
                completed.
              </div>
            </div>

            <div className="rule-row">
              <div className="rule-icon rule-blue-bg">
                <i className="fa-solid fa-layer-group rule-blue-icon"></i>
              </div>

              <div className="rule-text">
                <strong>Maximum 2 sprints</strong> per
                project — one In Progress and one in
                Planning. Both slots must be freed to
                create a third.
              </div>
            </div>

            <div className="rule-row">
              <div className="rule-icon rule-red-bg">
                <i className="fa-solid fa-lock rule-red-icon"></i>
              </div>

              <div className="rule-text">
                <strong>Create sprint is blocked</strong>
                when both an active and a planning
                sprint already exist.
              </div>
            </div>

            <div className="rule-row">
              <div className="rule-icon rule-yellow-bg">
                <i className="fa-solid fa-pause rule-yellow-icon"></i>
              </div>

              <div className="rule-text">
                <strong>Paused sprint</strong> occupies
                the active slot — no new sprint can
                be started until it is stopped.
              </div>
            </div>

            <div className="rule-row">
              <div className="rule-icon rule-danger-bg">
                <i className="fa-solid fa-trash rule-danger-icon"></i>
              </div>

              <div className="rule-text">
                <strong>Only Planning sprints</strong>
                can be deleted. Active and paused
                sprints must be stopped first.
              </div>
            </div>
          </div>
        </div>
      {/* )} */}
    </>
  )
}

export default SprintRules